import React, { Component } from "react";
import {
  Badge,
  Alert,
  Button,
  Collapse,
  Drawer,
  Input,
  message,
  Tooltip,
} from "antd";
import {
  DesktopOutlined,
  FilePdfOutlined,
  MobileOutlined, ArrowRightOutlined,
  WifiOutlined,
} from "@ant-design/icons";
import { assistant } from "../../utils/axios/assistant";
import { backoffice } from "../../utils/axios/backoffice";

const { Search } = Input;

class CustomerSettings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      clientServices: null,
      clientBillings: null,
      connectProfile: {
        connected: false,
        loading: false,
        open: false,
        validationMessage: "",
        clientData: {},
        client_id: "",
      },
      changeName: {
        loading: false,
        open: false,
        name: ""
      },
    };
    this.updateContact = this.updateContact.bind(this);
    this.updateName = this.updateName.bind(this);
  }
  componentDidMount() {
    const { selectedClient } = this.props;
    const { connectProfile } = this.state;
    if (selectedClient) {
      const client_id =
        selectedClient && typeof selectedClient.contact.client_id === "string"
          ? selectedClient.contact.client_id
          : "";
      if (client_id) {
        backoffice
          .get(`/client-services/${client_id}`)
          .then(({ data }) =>
            this.setState({ clientServices: data.services })
          );
        backoffice
          .get(`/client-billings/${client_id}`)
          .then(({ data }) => this.setState({ clientBillings: data }));
      }

      if (client_id) {
        this.setState({
          connectProfile: {
            ...connectProfile,
            connected: true,
            client_id,
          },
        });
      }
    }
  }
  componentDidUpdate(prevProps) {
    const { selectedClient } = this.props;
    const { connectProfile } = this.state;
    if (
      prevProps.selectedClient !== selectedClient &&
      typeof selectedClient !== "undefined"
    ) {

      const client_id =
        selectedClient && typeof selectedClient.contact.client_id === "string"
          ? selectedClient.contact.client_id
          : "";
      if (client_id) {
        backoffice
          .get(`/client-services/${client_id}`)
          .then(({ data }) =>
            this.setState({ clientServices: data.services })
          );
        backoffice
          .get(`/client-billings/${client_id}`)
          .then(({ data }) => this.setState({ clientBillings: data }));
      } else {
        this.setState({
          clientServices: null,
          clientBillings: null,
        });
      }
      if (client_id) {
        this.setState({
          connectProfile: {
            ...connectProfile,
            connected: true,
            client_id,
          },
        });
      } else {
        this.setState({
          connectProfile: {
            ...connectProfile,
            connected: false,
            client_id,
          },
        });
      }
    }
  }

  async getClient(value) {
    try {
      const { data } = await backoffice.post("/client-validate", {
        dni: value,
      });
      if (data.ok) {
        if (data.isClient === false) {
          message.error(
            "El DNI/NIE/CIF enviado no pertenece a ningún cliente."
          );
        }
        if (data.isClient) {
          const clientName = data.client.name;

          this.setState({
            connectProfile: {
              ...this.state.connectProfile,
              clientData: data.client,
              validationMessage: `El documento enviado pertenece a la ficha de cliente de ${clientName}.\n¿Estás seguro de que deseas vincular este WhatsApp con dicha ficha de cliente?`,
            },
          });
        }
      }
    } catch (error) {
      console.warn(error);
      message.error("Hubo un error al validar el DNI/NIE/CIF.");
    }
  }

  async updateContact() {
    const { clientData } = this.state.connectProfile;
    const { selectedClient } = this.props;
    try {
      const { data } = await assistant.post("/connect-with-customer", {
        contact_id: selectedClient.contact.id,
        client_id: clientData.id,
      });
      if (data.ok) {
        message.success(
          "El chat se ha vinculado correctamente con la ficha del cliente."
        );
        this.setState({
          connectProfile: {
            ...this.state.connectProfile,
            open: false,
            client_id: data.data.client_id,
            connected: true,
          },
        });
      } else {
        message.error(
          "Hubo un error al querer vincular el chat con la ficha del cliente."
        );
      }
    } catch (error) {
      message.error(
        "Hubo un error al querer vincular el chat con la ficha del cliente."
      );
    }
  }
  async updateName() {
    const { selectedClient } = this.props;
    const { changeName } = this.state;
    try {
      const { data } = await assistant.put("/change-contact-name", {
        id: selectedClient.contact.id,
        name: changeName.name,
      });
      if (data.ok) {
        message.success(
          "El nombre se ha guardado correctamente."
        );
        this.props.handleFiltersChange({ forceRefetch: true });
        this.props.refetchContacts();
        this.setState({
          changeName: {
            ...changeName,
            open: false,
            name: "",
          },
        });
      } else {
        message.error(
          "Hubo un error al querer guardar el nombre."
        );
      }
    } catch (error) {
      message.error(
        "Hubo un error al querer guardar el nombre."
      );
    }
  }
  render() {
    const { clientServices, clientBillings, connectProfile, changeName } = this.state;
    const { isOpen, onClose, selectedClient } = this.props;
    const formattedData = {
      phone: "",
    };
    const customerProfile = () => {
      let isButtonDisabled = true;
      if (selectedClient) {
        isButtonDisabled = selectedClient.client_id === null;
      }
      if (selectedClient) {
        const prop = selectedClient.contact.phone;
        const prefix = prop.slice(0, 2);
        const mainNumber = prop.slice(2);
        const groupedNumber = mainNumber.match(/.{1,3}/g).join(" ");
        formattedData.phone = `+${prefix} ${groupedNumber}`;
      }
      return (
        <div>
          {selectedClient && (
            <div>
              <div style={{ marginBottom: 16 }}>
                <p
                  style={{ margin: 0 }}
                >{`Nombre: ${selectedClient.contact.name ? selectedClient.contact.name : ""}`}</p>
                <p
                  style={{ margin: 0 }}
                >{`Teléfono: ${formattedData.phone}`}</p>
              </div>
              <div style={{ marginBottom: 16 }}>
                <Button
                  type="default"
                  style={{ width: "100%" }}
                  disabled={!this.state.connectProfile.connected}
                  onClick={() =>
                    window.open(`/clientes/fichas/${connectProfile.client_id}`, "_blank")
                  }
                >
                  Ir a la ficha del cliente
                </Button>
              </div>
              <div style={{ display: "flex", flexDirection: "row", gap: 8, marginBottom: 16 }}>
                <Button
                  type="primary"
                  style={{ width: "100%" }}
                  disabled={this.state.connectProfile.connected}
                  onClick={() =>
                    this.setState({
                      connectProfile: { ...connectProfile, open: !connectProfile.open },
                    })
                  }
                >
                  Conectar ficha
                </Button>
                <Button
                  type="primary"
                  style={{ width: "100%" }}
                  onClick={() =>
                    this.setState({
                      changeName: { ...changeName, open: !changeName.open },
                    })
                  }
                >
                  Cambiar nombre
                </Button>
              </div>
              <div>
                {changeName.open &&
                  <div style={{ marginTop: 20 }}>
                    <p style={{ margin: 0 }}>Nombre</p>
                    <Input
                      allowClear
                      placeholder="Nombre del cliente"
                      value={changeName.name}
                      suffix={<ArrowRightOutlined />}
                      onPressEnter={this.updateName}
                      onChange={(e) =>
                        this.setState({
                          changeName: {
                            ...changeName,
                            name: e.target.value,
                          },
                        })
                      } />
                  </div>
                }
                {this.state.connectProfile.open && (
                  <div style={{ marginTop: 20 }}>
                    <p style={{ margin: 0 }}>DNI/NIE/CIF</p>
                    <Search
                      allowClear
                      placeholder="DNI del cliente"
                      onSearch={(value) => this.getClient(value)}
                    />
                    {connectProfile.validationMessage &&
                      connectProfile.validationMessage.length > 0 && (
                        <div>
                          <Alert
                            style={{ marginTop: 10, marginBottom: 4 }}
                            message={connectProfile.validationMessage}
                            type="info"
                          />
                          <Button
                            block
                            type="primary"
                            onClick={this.updateContact}
                          >
                            Confirmar
                          </Button>
                        </div>
                      )}
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      );
    };
    return (
      <Drawer
        maskClosable={false}
        title={"Datos cliente"}
        onClose={() => onClose()}
        open={isOpen}
      >
        <div
          style={{
            marginBottom: 24,
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-evenly",
          }}
        >
          <Tooltip
            placement="bottom"
            trigger={["hover"]}
            title={clientServices && clientServices.internet_plan}
          >
            <WifiOutlined
              style={{
                padding: 10,
                fontSize: "20px",
                borderRadius: "50%",
                backgroundColor:
                  clientServices && clientServices.internet
                    ? "#46b98a"
                    : "grey",
                color: "white",
              }}
            />
          </Tooltip>
          <Tooltip
            placement="bottom"
            trigger={["hover"]}
            title={
              clientServices &&
              clientServices.mobiles.map((mobile) => (
                <p>
                  {mobile.number} | {mobile.plan}
                </p>
              ))
            }
          >
            <Badge
              count={clientServices && clientServices.mobiles_count}
              offset={[0, 2]}
            >
              <div
                style={{
                  width: 40,
                  height: 40,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  borderRadius: "50%",
                  backgroundColor:
                    clientServices && clientServices.mobile
                      ? "#46b98a"
                      : "grey",
                }}
              >
                <MobileOutlined
                  style={{
                    fontSize: "20px",
                    color: "white",
                  }}
                />
              </div>
            </Badge>
          </Tooltip>
          <Tooltip
            placement="bottom"
            trigger={["hover"]}
            title={clientServices && clientServices.tv_plan}
          >
            <DesktopOutlined
              style={{
                padding: 10,
                fontSize: "20px",
                borderRadius: "50%",
                backgroundColor:
                  clientServices && clientServices.tv ? "#46b98a" : "grey",
                color: "white",
              }}
            />
          </Tooltip>
          <Tooltip
            placement="bottom"
            trigger={["hover"]}
            title={
              clientBillings && [
                <p>Total facturado:{clientBillings.total_billed}</p>,
                <p>Pendiente:{clientBillings.total_billed}</p>,
              ]
            }
          >
            <Badge
              count={clientBillings && clientBillings.orders_count}
              offset={[0, 2]}
            >
              <div
                style={{
                  width: 40,
                  height: 40,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  backgroundColor:
                    clientBillings && clientBillings.total_remaining > 0
                      ? "rgb(255, 94, 94)"
                      : clientBillings && clientBillings.orders_count
                        ? "grey"
                        : "#46b98a",
                  borderRadius: "50%",
                }}
              >
                <FilePdfOutlined
                  style={{
                    fontSize: "20px",
                    color: "white",
                  }}
                />
              </div>
            </Badge>
          </Tooltip>
        </div>

        <Collapse
          expandIconPosition="end"
          bordered={false}
          items={[
            {
              key: "1",
              label: "Datos del cliente",
              children: customerProfile(),
            },
          ]}
        />
      </Drawer>
    );
  }
}

export default CustomerSettings;



// WEBPACK FOOTER //
// ./src/views/NaduChat/CustomerSettings.jsx